import { Component, inject, Input } from '@angular/core';

import { UiSession } from '@brighthub/uisession';
import { CopilotFacadeService } from '@brighthub/copilot';
import { ConversationInfoComponent } from '../conversation-info/conversation-info.component';
import { Router } from '@angular/router';
import { ConversationService } from '../conversation.service';

@Component({
  selector: 'lib-conversation-search-result-wrapper',
  imports: [ConversationInfoComponent],
  templateUrl: './conversation-search-result-wrapper.component.html',
  styleUrl: './conversation-search-result-wrapper.component.scss',
})
export class ConversationSearchResultWrapperComponent {
  @Input() data!: UiSession;
  @Input() providerId!: string;

  private _router = inject(Router);
  readonly conversationService = inject(ConversationService);

  selectConversation(conversation: UiSession) {
    this.conversationService.setActiveConversation(conversation);
    this._router.navigate([`/brightnav/conversation/${conversation.conversationId}`]);
  }

}
